import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'atyl-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.scss']
})
export class AddressCardComponent implements OnInit {


  @Input() consultation: any = null;
  @Input() dossier: any = null;

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    console.log('consultation', this.consultation)
  }
  ngOnchanges() {
    console.log('consultation', this.consultation)
    this.changeDetectorRef.detectChanges()
  }

}
